const schema = [
        ['startDate'],
        ['endDate'],
        ['approved'],
        ['note'],
        ['user'],
];

export default schema;
